const SERVINGS_PER_MONTH = 30;

export function getPricePerMonth(servings: number, priceAmount: number) {
  const numMonths = servings / SERVINGS_PER_MONTH;
  const pricePerMonth = priceAmount / numMonths;
  return pricePerMonth;
}
